import Script from 'react-load-script';
import React, { Component } from 'react';

class Recaptcha extends Component {
  constructor(props) {
    super(props);
    this.$captchaInterval = null;
  }

  captchaTimestamp = () => {
    var response = document.getElementById('g-recaptcha-response');
    if (response === null || response.value.trim() === '') {
      var elems = JSON.parse(
        document.getElementsByName('captcha_settings')[0].value
      );
      elems['ts'] = JSON.stringify(new Date().getTime());
      document.getElementsByName('captcha_settings')[0].value = JSON.stringify(
        elems
      );
    }
  };

  handleLoadCaptcha = () => {
    this.$captchaInterval = setInterval(this.captchaTimestamp, 500);
  };

  componentWillUnmount() {
    clearInterval(this.$captchaInterval);
  }

  render() {
    return (
      <Script
        url="https://www.google.com/recaptcha/api.js"
        onLoad={this.handleLoadCaptcha}
      />
    );
  }
}

export default Recaptcha;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Recaptcha.js